import React from "react";

function LccPNR() {
  return <div>LccPNR</div>;
}

export default LccPNR;
